'use es6';

import { createSelector } from 'reselect';
import { getIsAttachmentDisabled } from '../operators/getIsAttachmentDisabled';
import { getWidgetUiState } from '../../selectors/getWidgetUiState';
export const getShouldDisableAttachments = createSelector([getWidgetUiState], widgetUiState => getIsAttachmentDisabled(widgetUiState));